module.exports = __webpack_public_path__ + "img/red-circle.6894fc72.png";